import React, { createContext, useContext, useEffect, useState } from 'react';

const MenuItemsContext = createContext<any>(undefined);

const MenuItemsProvider = (props: any) => {
	const _menu = JSON.parse(localStorage.getItem('menu') || '[]');
	const [menuItems, setMenuItems] = useState<any[]>(_menu);

	const saveToLocalStorage = (menuItem: any[]) => {
		localStorage.setItem('menu', JSON.stringify(menuItem));
	};

	useEffect(() => {
		saveToLocalStorage(menuItems);
	}, [menuItems]);

	return <MenuItemsContext.Provider value={{ setMenuItems, menuItems }} {...props} />;
};

function useMenuItems() {
	const context = useContext(MenuItemsContext);

	if (context === undefined) {
		throw new Error(`useMenuItems must be used within a MenuItemsProvider`);
	}

	return context;
}

export { MenuItemsProvider, useMenuItems };
